import React from 'react'
import Layout from '../components/layout/Layout'
import { Link } from 'gatsby'
import { SEO } from 'gatsby-theme-seo'
import DecryptTitle from '../components/decryptTitle'

import { INLINES, BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const Contato = ({ data }) => {
  const { contentfulPaginas } = data

  return (
    <Layout id="Contato"  additionalClassName="md:h-screen" contentAlignment="center">
      <SEO title="Contato" />
      <div className="container mx-auto">
        <div className="w-full h-full bg-criptoBlue-100 py-10 px-16 flex flew-wrap" >
          <div className="w-1/2 h-full text-left flex items-center">
            <div className="w-full">
              <DecryptTitle data={data} className="text-5xl font-semibold text-criptoBlue-700" />
              
              <div className="text-xl font-light text-gray-700 pt-4 pr-10">
              {documentToReactComponents(contentfulPaginas.body.json, {
              renderMark: {
              [MARKS.BOLD]: text => <span className="font-bold">{text}</span>,
              [MARKS.ITALIC]: text => <span className="italic]">{text}</span>,
              [MARKS.UNDERLINE]: text => <span className="underline">{text}</span>,
              [MARKS.CODE]: text => <span className="font-mono tracking-wider">{text}</span>,
              },
              renderNode: {
              [BLOCKS.HEADING_1]: (_node, children) => (
              <h1>{children}</h1>
              ),
              [BLOCKS.HEADING_2]: (_node, children) => (
              <h2>{children}</h2>
              ),
              [BLOCKS.HEADING31]: (_node, children) => (
              <h3>{children}</h3>
              ),
              [BLOCKS.HEADING_4]: (_node, children) => (
              <h4>{children}</h4>
              ),
              [BLOCKS.HEADING_5]: (_node, children) => (
              <h5>{children}</h5>
              ),
              [BLOCKS.HEADING_6]: (_node, children) => (
              <h6>{children}</h6>
              ),
              [INLINES.HYPERLINK]: (node, children) => {
              return <Link to={node.data.uri} className="title hover:bg-criptoOrange-500 px-1 -ml-1">{children}</Link>
              },
              [BLOCKS.PARAGRAPH]: (_node, children) => <p className="mt-2">{children}</p>,
              [BLOCKS.QUOTE]: (_node, children) => <blockquote>{children}</blockquote>,
              },
              })}
              </div>
              </div>
          </div>

          
          <div className="w-1/2 h-full">
            <div className="font-display uppercase tracking-wider text-criptoBlue-800 pl-12">
              <form method="post" netlify-honeypot="bot-field" data-netlify="true" id="contato_cripto">
                <div className="w-full h-full flex flex-wrap">
                  <input type="hidden" name="bot-field" />
                  <label className="mx-2 mt-2 w-full">
                  E-mail
                  <input type="email" name="email" className="font-body p-2 text-gray-800 w-full" />
                  </label>
                  <label className="mx-2 mt-2 w-full">
                  Nome
                  <input type="text" name="name" className="font-body p-2 text-gray-800 w-full" />
                  </label>
                  <label className="mx-2 mt-2 w-full">
                  Mensagem
                  <textarea type="text" rows="5" name="message" className="font-body p-2 text-gray-800 w-full" />
                  </label>
                  <button type="submit" form="contato_cripto" value="Submit" className="bg-criptoOrange-400 text-criptoBlue-900 hover:text-white hover:bg-criptoBlue-700 px-5 py-2 text-xl -mt-3 z-20 rounded-sm mx-auto w-auto text-white">Enviar</button>
                </div>
            </form>

          </div>

          </div>
        </div>
      </div>
        
    </Layout>

  )
}

export default Contato

export const pageQuery = graphql`
  query {
    contentfulPaginas(
      slug: {
        eq: "contato"
      }
    ) {
      titulo
      decrypt
      tituloDecrypt {
        textoNormal
        textoDecrypt
        posicionamento
      }
      body {
        json
      }
    }
  }
`